// A single-line text input with its label, laid out the way the app's TextInput /
// FormItem pair is: the label is shown as the field's placeholder, and the field
// sits in a block with the app's form spacing (see .text-field in index.css).
//
// The <label> is still rendered — visually hidden — because a placeholder is not
// an accessible name: it disappears once the field has a value and is not
// reliably announced by screen readers. Keeping a real label also keeps browser
// autofill and label-based lookups (tests, getByLabel) working. That policy lives
// here so screens cannot copy the pattern half-right.
//
// `type="email"` applies the attribute bundle an email field needs on the web:
// browser autofill of the user's email, and no autocapitalise / spellcheck, which
// would otherwise "correct" the address on mobile keyboards. `errorId` is the id
// of the message describing the current error; passing it marks the field
// invalid AND points it at the message, so the two can never drift apart. `error`
// does the same for a message of the field's own, which it shows under itself
// (a form-wide message lives elsewhere, so it takes `errorId`). Any other prop
// goes straight to the <input>. `adornment` renders inside the control row, at
// the input's right edge (the password Show / Hide toggle).
const PRESETS = {
  email: { autoComplete: 'email', autoCapitalize: 'none', spellCheck: false },
};

export default function TextField({
  id,
  label,
  type = 'text',
  errorId,
  error,
  className = '',
  adornment = null,
  ...inputProps
}) {
  const ownErrorId = error ? `${id}-error` : undefined;
  const describedBy = ownErrorId ?? errorId;

  return (
    <div className={`text-field ${className}`.trim()}>
      <label htmlFor={id} className="visually-hidden">
        {label}
      </label>
      <div className="text-field__control">
        <input
          id={id}
          type={type}
          placeholder={label}
          aria-invalid={describedBy ? true : undefined}
          aria-describedby={describedBy}
          {...PRESETS[type]}
          {...inputProps}
        />
        {adornment}
      </div>
      {error ? (
        <p id={ownErrorId} className="form-error">
          {error}
        </p>
      ) : null}
    </div>
  );
}
